export default __webpack_public_path__ + "static/media/background-1.c5424751.png";